import Collection_Base from 'collection/base';
import Model_Survey from 'model/survey';

export default Collection_Base.extend({
    model: Model_Survey,
    loaded: false,

    sortSurveyByStatus: function(sort_order = 'ASC') {
        const status_order = ['activated', 'scheduled', 'deactivated'];

        if (sort_order === 'DESC') {
            status_order.reverse();
        }

        const sorted_surveys = [...this.models].sort((a, b) => {
            const status_a = a.getStatus();
            const status_b = b.getStatus();
            // Compare based on the index of each status in the order array
            return status_order.indexOf(status_a) - status_order.indexOf(status_b);
        });

        return sorted_surveys;
    },

    markAsLoaded: function() {
        this.loaded = true;
    },

    isLoaded: function() {
        return this.loaded;
    }
});